import { useNavigate } from 'react-router-dom'
import { Pencil, Trash2 } from 'lucide-react'

interface TableRowActionsProps {
  editTo?: string
  onDelete?: () => void
}

export function TableRowActions({ editTo, onDelete }: TableRowActionsProps) {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-end gap-1">
      {editTo && (
        <button
          onClick={() => navigate(editTo)}
          className="rounded-md p-1.5 text-neutral-400 transition-colors hover:bg-primary/10 hover:text-primary"
        >
          <Pencil className="h-4 w-4" />
        </button>
      )}
      {onDelete && (
        <button
          onClick={onDelete}
          className="rounded-md p-1.5 text-neutral-400 transition-colors hover:bg-red-50 hover:text-red-600"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
